(function() { window.GUID_b53b21d6_0b6b_42c5_9715_80e132425a9c = { getGuid: function() { return "b53b21d6-0b6b-42c5-9715-80e132425a9c"; } }; })();
var CS;
(function (CS) {
    class ScanBox {
        constructor(scanBox) {
            this.ScanBox = scanBox;
            this.PrepareScanBox();
        }
        PrepareScanBox() {
            let me = this;
            let waitingFocusMessage = me.ScanBox.data('waitingfocusmessage');
            let waitingScanMessage = me.ScanBox.data('waitingscanmessage');
            let inputBox = $('<input class=\"CSScanBoxInput\" type=\"text\"/>');
            let scanBoxMessage = $('<div class=\"CSScanBoxMessage\"><div class="WaitingFocusMessage">' + waitingFocusMessage + '</div><div class="WaitingScanMessage">' + waitingScanMessage + '</div></div>');
            me.ScanBox.append(inputBox);
            me.ScanBox.append(scanBoxMessage);
            me.InputBox = inputBox;
            me.ScanBoxMessage = scanBoxMessage;
            me.ScanBox.on('mouseup', function () {
                me.InputBox.focus();
            });
            me.InputBox.on('keydown', function () {
                CS.Lag(500, function () {
                    let scanValue = me.InputBox.val();
                    me.ScanBox.trigger('scanned', scanValue);
                    me.InputBox.val('');
                });
            }).on('blur', function () {
                me.ToggleWaitScanWaitFocus(false);
            }).on('focus', function () {
                me.InputBox.val('');
                me.InputBox.select();
                me.ToggleWaitScanWaitFocus(true);
            });
        }
        ToggleWaitScanWaitFocus(waitScan) {
            var me = this;
            if (waitScan) {
                me.ScanBox.addClass('WaitScan');
            }
            else {
                me.ScanBox.removeClass('WaitScan');
            }
        }
    }
    CS.ScanBox = ScanBox;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSScanBox = function () {
        this.each(function () {
            var scanBox = new CS.ScanBox($(this));
        });
    };
})(jQuery);


var CS = CS || {};

CS.ScanBox = function (scanBox) {
    var me = this;
    me.ScanBox = $(scanBox);
    me.PrepareScanBox();
};

CS.ScanBox.prototype = function () {

    var PrepareScanBox = function () {
        var me = this;

        var waitingFocusMessage = me.ScanBox.data('waitingfocusmessage');
        var waitingScanMessage = me.ScanBox.data('waitingscanmessage');

        var inputBox = $('<input class=\"CSScanBoxInput\" type=\"text\"/>');
        var scanBoxMessage = $('<div class=\"CSScanBoxMessage\"><div class="WaitingFocusMessage">' + waitingFocusMessage + '</div><div class="WaitingScanMessage">' + waitingScanMessage + '</div></div>');

        me.ScanBox.append(inputBox);
        me.ScanBox.append(scanBoxMessage);

        me.InputBox = inputBox;
        me.ScanBoxMessage = scanBoxMessage;

        me.ScanBox.on('mouseup', function () {
            me.InputBox.focus();
        });

        me.InputBox.on('keydown', function () {
            Lag(500, function () {
                var scanValue = me.InputBox.val();
                me.ScanBox.trigger('scanned', scanValue);
                me.InputBox.val('');
            });
        }).on('blur', function () {
            me.ToggleWaitScanWaitFocus(false);
        }).on('focus', function () {
            me.InputBox.val('');
            me.InputBox.select();
            me.ToggleWaitScanWaitFocus(true);
        });
    },
    ToggleWaitScanWaitFocus = function (waitScan) {
        var me = this;
        if (waitScan) {
            me.ScanBox.addClass('WaitScan');
        }
        else {
            me.ScanBox.removeClass('WaitScan');
        }
    };
    return {
        PrepareScanBox: PrepareScanBox,
        ToggleWaitScanWaitFocus: ToggleWaitScanWaitFocus
    };

}();
*/ 

//# sourceMappingURL=cs.scanbox.js.map
